import { useMedicine } from 'requests/medicaments';
import MedecineMenu from '../MedecineMenu/MedecineMenu';

const Biosimilaires = () => {
  const { data } = useMedicine({ fetchPolicy: 'no-cache' });
  const items = data?.medicines?.data
    ? [...data.medicines.data]
        .filter((m: any) => m?.biosimilaires?.length > 0)
        .sort((a, b) => a.name?.localeCompare(b.name))
    : [];

  return (
    <MedecineMenu
      data={items}
      count={false}
      pathname="/"
      sortFunction={(a, b) => a.name?.localeCompare(b.name)}
      title="Biosimilaires"
    />
  );
};

export default Biosimilaires;